import { createContext, useContext, type ReactNode } from 'react';

const OnboardingOverlayContainerContext = createContext<HTMLElement | null>(null);

export function OnboardingOverlayContainerProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: ReactNode;
}) {
  return (
    <OnboardingOverlayContainerContext.Provider value={container}>
      {children}
    </OnboardingOverlayContainerContext.Provider>
  );
}

export function useOnboardingOverlayContainer(): HTMLElement | null {
  return useContext(OnboardingOverlayContainerContext);
}
